import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';

export default function DataGridTable({ StudentList }) {
  // Columns configured for: S.No, Student Name, Reason, and Summary
  const columns = [
    {
      field: 'sno',
      headerName: 'S.No',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    {
      field: 'studentName',
      headerName: 'Student Name',
      width: 220,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'reason',
      headerName: 'Reason',
      width: 350,
      headerAlign: 'center',
      align: 'center',

      valueGetter: (value) => {
        const sentimentMap = {
          Medium: 'Slightly behind track',
          High: 'Extremely behind track',
        };
        if (value === 'Medium' || value === 'High') {
          return `Facilitator Flag: ${sentimentMap[value]}`;
        }
        if (value === 'Negative' || value === 'Neutral') {
          return `Student Sentiment: ${value}`;
        }
        return value;
      },

      sortComparator: (v1, v2) => {
        const order = ['Medium', 'High'];
        return order.indexOf(v1) - order.indexOf(v2);
      },
    },
    {
      field: 'summary',
      headerName: 'Summary',
      flex: 1,
      minWidth: 400,
      headerAlign: 'left',
      align: 'left',
    },
  ];

  // Map the JSON structure directly to row objects
  const rows = (StudentList || []).map((item, index) => ({
    id: item.student_classroom_id, 
    sno: index + 1,                
    studentName: item.student_name,
    reason: item.reason,
    summary: item.summary,
  }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        localeText={{ noRowsLabel: 'No Student available' }}
        pageSizeOptions={[20, 50, 100]}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '12px 6px', // Extra padding for readable wrapping of summaries
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
            whiteSpace: 'normal', // Ensures long summaries wrap onto multiple lines
            lineHeight: '1.5',
          },
        }}
      />
    </div>
  );
}